import React, { useState } from "react";
import {
  Drawer,
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import {
  getLocalValue,
  IsSmallScreen,
  LoacalVariables,
} from "../../commonFunctions/CommonFunctions";
import { getMenu } from "./menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Link, useLocation } from "react-router-dom";
// import logo from '../../images/logo.svg'
interface MenuItem {
  id: number;
  label: string;
  path?: string;
  icon: React.ElementType;
  children?: MenuItem[];
}

interface SidebarProps {
  open: boolean;
  handleDrawerToggle: () => void;
  handleCollapse: () => void;
  collapse: boolean;
  drawerWidth?: number;

  primaryColor: string;
  secondaryColor: string;
  hoverColor: string;
  textColor: string;
  iconColor: string;
  hoverTextColor: string;
  backgroundColor: string;
  selectedBackgroundColor: string;
  boxShadowColor: string;
}

const Sidebar2: React.FC<SidebarProps> = ({
  open,
  handleDrawerToggle,
  collapse,
  drawerWidth = 240,

  primaryColor,
  secondaryColor,
  textColor,
  hoverColor,
  hoverTextColor,
  backgroundColor,
  selectedBackgroundColor,
  boxShadowColor,
  iconColor,
}) => {
  const isMobile = IsSmallScreen();
  const location = useLocation(); // Get the current location from React Router

  const [hoveredMenuPosition, setHoveredMenuPosition] = useState({ top: 0 });

  const userType: any = getLocalValue(LoacalVariables.UserType);
  const [openChildMenus, setOpenChildMenus] = useState<Record<number, boolean>>(
    {}
  );
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const [hoveredMenuId, setHoveredMenuId] = useState<number | null>(null);

  // Helper function to determine if the menu item is selected
  const isSelected = (id: number, path?: string) =>
    location.pathname === path && selectedId === id;

  const menu = getMenu(userType);

  const handleToggleChildMenu = (id: number) => {
    setOpenChildMenus((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleMouseEnter = (id: number) => {
    setHoveredMenuId(id);

    // Find the hovered list item position
    const listItem = document.getElementById(`menu-item-${id}`);
    if (listItem) {
      const rect = listItem.getBoundingClientRect();
      setHoveredMenuPosition({ top: rect.top + window.scrollY });
    }
  };

  const handleMouseLeave = () => {
    setHoveredMenuId(null);
  };

  return (
    <Drawer
      variant={"persistent"}
      anchor="left"
      open={open}
      onClose={handleDrawerToggle}
      sx={{
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: collapse ? 80 : drawerWidth,
          overflowX: "hidden",
          transition: "width 0.3s ease",
          border: "1px solid #e3e3e3",

          // ✅ Position it under the Navbar
          position: "fixed",
          top: 80, // Match AppBar height
          height: "calc(100vh - 64px)", // Fill remaining vertical space
          left: 0,
          borderRadius: 8,
        },
      }}
    >
      <Box
        sx={{
          padding: collapse ? ".2rem" : "1.1rem",
        }}
      >
        {!collapse ? (
          <Typography
            sx={{ fontWeight: "bold", fontSize: "1.2rem", textAlign: "center" }}
          >
            {/* <img
              src={
                logo
              }
              alt="logo"
              width={80}
              height={20}
            /> */}
          </Typography>
        ) : (
          <Typography
            sx={{ fontWeight: "bold", fontSize: "1.2rem", textAlign: "center" }}
          >
            {/* <img
              src={
                logo
              }
              alt="logo"
              width={60}
              height={50}
            /> */}
          </Typography>
        )}
      </Box>

      {/* {!collapse && (
        <Typography sx={{ fontSize: "16px", p: 1, ml: 3 }}>
          Main Menu
        </Typography>
      )} */}
      {/* <Typography sx={{ ml: 2 }}>Dashboard</Typography> */}
      <List>
        {menu.staticMenu.map((item: MenuItem) => (
          <React.Fragment key={item.id}>
            <li
              id={`menu-item-${item.id}`} // Add unique ID
              style={{ padding: 4 }}
              onMouseEnter={() => handleMouseEnter(item.id)}
              onMouseLeave={handleMouseLeave}
            >
              <ListItemButton
                component={Link}
                to={item.path || "#"}
                onClick={() => {
                  setSelectedId(item.id); // <‑‑ remember which one was chosen
                  if (item.children) handleToggleChildMenu(item.id);
                }}
                sx={{
                  position: "relative",
                  minHeight: 48,
                  justifyContent: collapse ? "center" : "initial",
                  px: collapse ? 1.5 : 2.5,
                  left: 3,
                  borderRadius: "8px",
                  border: isSelected(item.id, item.path)
                    ? primaryColor
                    : "1px solid transparent",
                  boxShadow: isSelected(item.id, item.path)
                    ? secondaryColor
                    : "1px solid transparent",
                  transition: "background-color 0.4s ease",
                  backgroundColor: isSelected(item.id, item.path)
                    ? hoverColor
                    : "transparent",
                  color: isSelected(item.id, item.path)
                    ? hoverTextColor
                    : textColor,
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: 4, // bar thickness
                    borderRadius: "4px 0 0 4px",
                    backgroundColor: isSelected(item.id, item.path) // show only when selected
                      ? "#098963" // your green
                      : "transparent",
                    transition: "background-color 0.25s ease",
                  },
                  "&:hover": {
                    backgroundColor: hoverColor,
                    color: hoverTextColor,
                    boxShadow: secondaryColor,
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    width: 24,
                    height: 24,
                    // mr: collapse ? 0 : 1,
                    color: isSelected(item.id, item.path)
                    
                      ? hoverTextColor
                      : "#828584",
                    justifyContent: "center",
                  }}
                >
                  <item.icon />
                </ListItemIcon>
                {!collapse && (
                  <ListItemText
                    primary={item.label}
                    sx={{
                      "& .MuiTypography-root": {
                        fontSize: "0.875rem",
                        fontWeight: "bold",
                        marginLeft:-1
                      },
                    }}
                  />
                )}

                {item.children && !collapse && (
                  <ListItemIcon>
                    {openChildMenus[item.id] ? (
                      <ExpandMoreIcon sx={{ color: textColor,}} 
                      />
                    ) : (
                      <ExpandLessIcon sx={{ color: textColor }} />
                    )}
                  </ListItemIcon>
                )}
              </ListItemButton>
            </li>

            {/* Child Menu when Hover */}
            {item.children && collapse && hoveredMenuId === item.id && (
              <ul
                className="child-menu"
                style={{
                  position: "fixed",
                  left: 80,
                  top: hoveredMenuPosition.top,
                  zIndex: 1500,
                  backgroundColor: "#fff",
                  padding: "0",
                  margin: "0",
                  listStyle: "none",
                  borderRadius: 10,
                  boxShadow: `0 10px 30px ${boxShadowColor}`,
                }}
                onMouseEnter={() => setHoveredMenuId(item.id)} // Keep it open when hovered
                onMouseLeave={() => setHoveredMenuId(null)} // Close when mouse leaves
              >
                {item.children.map((child) => (
                  <li
                    key={child.id}
                    style={{ width: "14rem", borderRadius: 10 }}
                  >
                    <ListItemButton
                      component={Link}
                      to={child.path || "#"}
                      onClick={() => setSelectedId(child.id)}
                      sx={{
                        position: "relative",

                        padding: "8px",
                        height: 50,
                        color: textColor,
                        border: isSelected(child.id, child.path)
                          ? primaryColor
                          : "1px solid transparent",
                        boxShadow: isSelected(child.id, child.path)
                          ? secondaryColor
                          : "1px solid transparent",
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          left: 0,
                          top: 0,
                          bottom: 0,
                          width: 4, // bar thickness
                          borderRadius: "4px 0 0 4px",
                          backgroundColor: isSelected(child.id, child.path) // show only when selected
                            ? "#0fa958" // your green
                            : "transparent",
                          transition: "background-color 0.25s ease",
                        },
                        "&:hover": {
                          backgroundColor: hoverColor,
                          color: hoverTextColor,
                          boxShadow: secondaryColor,
                        },
                      }}
                    >
                      <ListItemText
                        primary={child.label}
                        sx={{
                          padding: "8px",
                          "& .MuiTypography-root": { fontSize: " 14px" },
                        }}
                      />
                    </ListItemButton>
                  </li>
                ))}
              </ul>
            )}

            {/* Child Menu when Expanded */}
            {item.children && openChildMenus[item.id] && !collapse && (
              <ul style={{ listStyle: "none", marginRight: "7px" }}>
                {item.children.map((child) => (
                  <li key={child.id}>
                    <ListItemButton
                      component={Link}
                      to={child.path || "#"}
                      onClick={() => setSelectedId(child.id)}
                      sx={{
                        position: "relative",
                        backgroundColor: isSelected(item.id, child.path)
                          ? hoverColor
                          : "transparent",
                        color: isSelected(item.id, child.path)
                          ? hoverTextColor
                          : textColor,
                        marginTop: "6px",
                        justifyContent: "initial",
                        borderRadius: "8px",
                        border: isSelected(child.id, child.path)
                          ? primaryColor
                          : "1px solid transparent",
                        boxShadow: isSelected(child.id, child.path)
                          ? secondaryColor
                          : "1px solid transparent",
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          left: 0,
                          top: 0,
                          bottom: 0,
                          width: 4, // bar thickness
                          borderRadius: "4px 0 0 4px",
                          backgroundColor: isSelected(child.id, child.path) // show only when selected
                            ? "#098963" // your green
                            : "transparent",
                          transition: "background-color 0.25s ease",
                        },
                        "&:hover": {
                          backgroundColor: hoverColor,
                          color: hoverTextColor,
                          boxShadow: secondaryColor,
                        },
                      }}
                    >
                      <ListItemText
                        primary={child.label}
                        sx={{
                          "& .MuiTypography-root": { fontSize: "14px" },
                        }}
                      />
                    </ListItemButton>
                  </li>
                ))}
              </ul>
            )}
          </React.Fragment>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar2;
